import React, { Component } from 'react';
import {Icon, Button, Segment} from 'semantic-ui-react';
import { toIDR } from '../../../../../_utils/tocurrency';
import { toDMYDate } from '../../../../../_utils/convert_datetime';
import printJS from 'print-js';
import { isBank, isVerificator, isAdmin } from '../../../../../_utils/localstorage';
import {BaseURLDev, headers} from "../../../../../_utils/config";
import swal from "sweetalert";


export default class ListBP extends Component {

   constructor(props){
      super(props);
      this.state = {
        datas: props.data_detail,
        total: [],
        status: [],
        jumlah: 0,
        semua: false,
        is_checking: true,
        semua_data: [],
        data: [],
      }
   }

   componentDidMount = async() => {
    //    const {datas} = this.state;
       await this.setState({is_checking: false});
//        await this.checkDatBP(datas);
   };

    exportData(){
        printJS({
            printable: 'print_data',
            type: 'html',
            modalMessage:"Sedang memuat data...",
            showModal:true,
            maxWidth:'1300',
            font_size:'8pt',
            documentTitle:'Rincian STS',
            targetStyle: [
                'margin',
                'color',
                'border-collapse',
                'border-spacing',
                'border-style',
                'border-style',
                'margin-bottom',
                'padding',
                'Label',
                'background'
            ]
        })
    }


   render() {
    const styletb = {
        borderCollapse:'collapse',
        borderSpacing:0,
        borderStyle:'solid',
        width:'100%',
        fontSize:'12px',
        padding:'10px'
    }
    const { datas } = this.state;
    var total1=[]; var status1=[]; var jumlah1=0;
    for(var i=0;i<1;i++){
        var total2=[]; var status2=[]; var jumlah2=0;
        for(var j=0; j<datas.bp.length;j++){
            var tam3=0; var stat2="";
            for(var k=0; k<datas.bp[j].rincian.length;k++){
                tam3=tam3+datas.bp[j].rincian[k].nilai;
            }
            if(datas.bp[j].is_active===true && datas.bp[j].is_verified===false){
                stat2="BP Non STS";
            } else if(datas.bp[j].is_active===false && datas.bp[j].is_verified===false){
                stat2="BP STS";
            } else if(datas.bp[j].is_active===false && datas.bp[j].is_verified===true){
                stat2="BP Terealisasi";
            }
            total2[j]=tam3;
            jumlah2=jumlah2+tam3;
            status2[j]=stat2;
        }
        total1[i]=total2;
        jumlah1=jumlah1+jumlah2;
        status1[i]=status2;
    }

    // console.log('bp', datas.bp)
        return (
            <Segment>
                <div>
                    {!isBank() &&
                        <Button color='blue' size="small" onClick={()=>this.exportData()}>
                            <p><Icon name='print' className='left floated' />Preview</p>
                        </Button>
                    }
                    <br/><br/>
                    <div ref={el => (this.componentRef = el)}>
                    <table border="1" align="center" style={styletb} id="print_data" width="100%">
                        <tbody>
                            <tr align="left" style={{background:'#e5e5e5',padding:'4px'}}>
                                <th rowSpan="2" width="4%" style={{padding:'4px',textAlign:"center"}}>No.</th>
                                {/* <th rowSpan="2" width="6%"style={{padding:'4px',textAlign:"center"}}>Status</th> */}
                                <th colSpan="2" width="20%" style={{padding:'4px',textAlign:"center"}}>Nomor</th>
                                <th colSpan="2" style={{padding:'4px',textAlign:"center"}}>Tanggal</th>
                                <th rowSpan="2" style={{padding:'4px',textAlign:"center"}}>Keterangan</th>
                                <th rowSpan="2" style={{padding:'4px',textAlign:"center"}}>Rincian</th>
                                <th rowSpan="2" style={{padding:'4px',textAlign:"center"}}>Total</th>
                            </tr>
                            <tr align="left" style={{background:'#e5e5e5',padding:'4px'}}>
                                <th style={{padding:'4px',textAlign:"center"}}>BP</th>
                                <th style={{padding:'4px',textAlign:"center"}}>STS</th>
                                <th style={{padding:'4px',textAlign:"center"}}>Pembuatan</th>
                                <th style={{padding:'4px',textAlign:"center"}}>Realisasi</th>
                            </tr>
                            {datas.bp.length === 0 &&
                                <td>
                                    <td colSpan="8">Data tidak ditemukan</td>
                                </td>
                            }
                            {datas.bp.map((item,i) => (
                                <tr key={i}>
                                    <td style={{padding:'4px',textAlign:"center"}}>{i+1}.</td>
                                    {/* <td>
                                    {
                                        (status1[0][i]==="BP Non STS")?
                                        <Label color='red' horizontal>BP Non STS</Label> :
                                        (status1[0][i]==="BP STS")?
                                        <Label color='yellow' horizontal>BP STS</Label> :
                                        (status1[0][i]==="BP Terealisasi")?
                                        <Label color='blue' horizontal>BP Terealisasi</Label> : null
                                    }
                                    </td> */}
                                    {/* {(isAdmin() || isVerificator()) ?
                                        item.status_bp ?
                                            <td style={{padding:'4px',textAlign:"center"}}>
                                                {item.no_bukti}
                                            </td>
                                            :
                                            <td style={{padding:'4px',textAlign:"center", backgroundColor: 'rgba(231, 76, 60, 0.5)'}}>
                                                {item.no_bukti}
                                            </td>
                                        :
                                        <td style={{padding:'4px',textAlign:"center"}}>
                                            {item.no_bukti}
                                        </td>
                                    } */}
                                    <td style={{padding:'4px',textAlign:"center"}}>
                                        {item.no_bukti}
                                    </td>
                                    {
                                        (i !== 0)? null :
                                        <td style={{textAlign:"center"}} rowSpan={datas.bp.length}>{ datas.no_sts }</td>
                                    }
                                    <td style={{padding:'4px',textAlign:"center"}}>{toDMYDate(item.created_at)}</td>
                                    <td style={{padding:'4px',textAlign:"center"}}>{toDMYDate(item.tgl_realisasi)}</td>
                                    <td style={{padding:'4px'}}>{item.uraian}</td>
                                    <td style={{padding:'4px'}}>
                                    {
                                        item.rincian.map((isi, j) =>(
                                            <p key={j}>
                                                {isi.kd_rek_1+"."+isi.kd_rek_2+"."+isi.kd_rek_3+"."+isi.kd_rek_4+"."+isi.kd_rek_5+"."+isi.kd_rek_6+" = "+isi.uraian_rinc+" : "+toIDR(isi.nilai)}
                                                {/* {' '}
                                                {
                                                    ((isAdmin() || isVerificator()) && !isi.checkStatusSimdaBPrincian) ? <Icon name='close' color={'red'} className='left floated' /> : <Icon name="check" color={'green'} className="left floated" />
                                                } */}
                                                <br/>
                                            </p>
                                        ))
                                    }
                                    </td>
                                    <td style={{padding:'4px',textAlign:"right"}}>{toIDR(total1[0][i])}</td>
                                </tr>
                            ))}
                            <tr style={{background:'#e5e5e5'}}>
                                <th style={{padding:'4px'}} colSpan="7" align="right">Jumlah</th>
                                <th style={{padding:'4px'}} align="right">
                                    {toIDR(jumlah1)}
                                </th>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
            </Segment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_sts/ListBP.js